import * as auth from './auth';
import * as db from './db';
import * as functions from './functions';
import * as firebase from './firebase';

export {
  auth,
  db,
  firebase,
  functions
};


// WEBPACK FOOTER //
// ./src/firebase/index.js